import { useCallback } from "react";
import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import type { EntityScope } from "../../shared/scope";
import { AdminWrittenAccountPreviewsAll } from "./AdminWrittenAccountPreviewsAll";
import { AdminWrittenAccountPreviewsClosed } from "./AdminWrittenAccountPreviewsClosed";
import { AdminWrittenAccountPreviewsOpen } from "./AdminWrittenAccountPreviewsOpen";
import { WrittenAccountMetricsView } from "./written-metrics/WrittenAccountMetricsView";

export const AdminWrittenAccountsView = () => {
	const renderMetrics = useCallback(
		(scope: EntityScope) => <WrittenAccountMetricsView scope={scope} />,
		[],
	);

	return (
		<EntityPreviewsLayout
			title="Written Accounts"
			storageKey="admin_account_written_view"
			enableScope
			renderMetrics={renderMetrics}
			tabs={[
				{
					id: "all",
					label: "All",
					Component: AdminWrittenAccountPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					Component: AdminWrittenAccountPreviewsOpen,
					isDefault: true,
				},
				{
					id: "closed",
					label: "Closed",
					Component: AdminWrittenAccountPreviewsClosed,
				},
			]}
		/>
	);
};
